import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/landing';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonios" className="bg-cream-deep" data-id="element-199" data-mp="1n0addghtiqw3">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" style={{
      backgroundColor: "#FFFFFF",
      backgroundImage: "none"
    }} data-id="element-200" data-mp="1mxxxd8vmeqlo">
        <SectionHeading eyebrow="⭐ TESTIMONIOS REALES" title={<>
              Lo que puede cambiar cuando empiezas a{' '}
              <span className="italic text-coral" data-id="element-202" data-mp="1i2iokvcgzkw4">estudiar visualmente.</span>
            </>} data-id="element-201" data-mp="1d1l7km374ww7" />

        <ul className="mt-14 grid gap-6 lg:grid-cols-3" data-id="element-203" data-mp="142hmjckgy7f2">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded-2xl bg-cream p-8" data-id="element-204" data-mp="183t3yut6vmc6">
              <div className="flex gap-1" aria-label="5 de 5 estrellas" data-id="element-205" data-mp="2yg8um7n5gj8e">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-coral text-coral" aria-hidden="true" data-id="element-206" data-mp="32eon2r202jt7" data-mpi={index} />)}
              </div>
              <blockquote className="mt-5 font-display text-lg leading-relaxed text-ink" data-id="element-207" data-mp="2q2hop9ay0dqf">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-auto pt-6" data-id="element-208" data-mp="34qul27dxzylg">
                <p className="text-sm font-semibold text-ink" data-id="element-209" data-mp="2zskoptghery9">{testimonial.name}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}